export default "__VITE_ASSET__3a5308ee__"